<template>
  <main>
    <!-- Start Banner-->
    <div class="banner">
      <div class="container custom">
        <div class="row align-items-center">
          <div class="col-xl-5 col-lg-5 ml-auto">
            <div class="banner__content">
              <div class="banner__content-title">DEVELOPMENT TEAM</div>
              <p>With experiences and solid knowledge of software development process, TimeBird has divided the team into highly specialized groups that are coordinated by clear and transparent workflows
                <br>~ 50% of Team members have more than 5 years of programing Web/App
                <br>~ 40% of Team members are Middle/Junior with 2 years of experience and above
                <br>~ 10% of Team members are Freshers, talents of prestigious universities in Hanoi</p>
              <br>
              <p>TimeBird is keen to create a dynamic, highly specialized and professional environment that creates opportunities for young talents to soon participate in real projects and to be trained in the real business environment.</p>
            </div>
          </div>
          <div class="col-xl-7 col-lg-7">
            <div class="banner__image">
              <img src="/assets/images/layouts/banner-team.png" alt="banner">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner-->
    <!-- Start BOD -->
    <div class="section team">
      <div class="container">
        <div class="section__content">
          <div class="section__content-title">
            BOD
            <span></span>
          </div>
        </div>
      </div>
      <div class="container custom">
        <div class="cover">
          <div class="row">
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-01.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">HAI Nguyen</div>
                    <div class="content__info-position">CEO & CTO</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 1">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 1}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-01.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">HAI Nguyen</div>
                  <div class="content__position">
                    HEAD OF BACK-END
                    <br>PROGRAMMING DEPARTMENT
                  </div>
                  <div class="content__description">
                    <p>With more than 13 years of experience in the software industry, Hai has taken part in constructing and designing dozen of utility softwares for users, both individuals and corporates. </p>
                    <p>In 2018, Hai joined Techcom and soon became Technology Director, in charge of exchange platforms such as ex.timebit.sg (live on Coinmarketcap in 2019), helped to determine strategies for Techcom. </p>
                    <p>Since 2020, Hai’s officially managed Timebird Joint stock company (which was previously Research and Development center of Techcom).</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 1}"></div>
            </div>
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-02.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">HUNG Cao</div>
                    <div class="content__info-position">CDO</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 2">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 2}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-02.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">HUNG Cao</div>
                  <div class="content__position">CDO</div>
                  <div class="content__description">
                    <p>Spent more than 8 years in Java and approximate 4 years in Researching and Deploying Blockchain, Hung is now a key factor in the company, in charge of production section of TimeBird including the financial products on Cloud.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 2}"></div>
            </div>
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-03.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">DUONG Tran</div>
                    <div class="content__info-position">COO</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 3">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 3}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-03.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">DUONG Tran</div>
                  <div class="content__position">COO</div>
                  <div class="content__description">
                    <p>With more than 10 years of experience in production, business, Human resources and a firm base of management knowledge from CFVG, Duong’s in charge of building and developing Timebird’s culture, completing processes and policies to facilitate all departments to operate smoothly and effectively.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 3}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End BOD -->
    <!-- Start Leadership -->
    <div class="section team">
      <div class="container">
        <div class="section__content">
          <div class="section__content-title">
            Leadership
            <span></span>
          </div>
        </div>
      </div>
      <div class="container custom">
        <div class="cover">
          <div class="row">
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-05.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">PHUC Nguyen</div>
                    <div class="content__info-position">AI CONSULTANT</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 5">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 5}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-05.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">PHUC Nguyen</div>
                  <div class="content__position">AI CONSULTANT</div>
                  <div class="content__description">
                    <p>After getting a wealth of knowledge from Hanoi University of Science and Technology’s professors, Phuc continued to follow his passion for AI at Trento University, Italy. </p>
                    <p>His experience working for big firms such as FDK (Italy), VinBigData (Vietnam) helps him to quickly deploy all applications which strengthen the security and confidentiality, protect client’s assets safely.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 5}"></div>
            </div>
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-06.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">TRINH Tran</div>
                    <div class="content__info-position">MOBILE APPLICATION LEAD</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 6">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 6}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-06.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">TRINH Tran</div>
                  <div class="content__position">MOBILE APPLICATION LEAD</div>
                  <div class="content__description">
                    <p>Before in charge of Mobile Application Department at Timebird, Trinh was a full-stack developer at many big corporations such as FPT software, Framgia, Techcom. </p>
                    <p>With clear goal of offering users with high-speed applications and serving multiple needs of clients, Trinh and his team always eager to learn and apply new technology such as VueJs, Flutter, etc beside traditional frameworks.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 6}"></div>
            </div>
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-09.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">CHINH Tran</div>
                    <div class="content__info-position">
                      HEAD OF FRONT-END
                      <br>PROGRAMMING DEPARTMENT
                    </div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 9">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 9}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-09.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">CHINH Tran</div>
                  <div class="content__position">HEAD OF FRONT-END<br/>
                    PROGRAMMING DEPARTMENT</div>
                  <div class="content__description">
                    <p>Graduating from Hanoi University of Science and Technology, Chinh chose his own path which is developing themes that were sold and brought in high revenue on ThemeForest. </p>
                    <p>With a rich understanding of UI/UX which serves a wide range of domestic and foreign customers for more than 9 years, Chinh has contributed to improving and optimizing the UI/UX of TimeBird’s products.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 9}"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-10.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">LINH Vu</div>
                    <div class="content__info-position">DEVOPS LEAD</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 10">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 10}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-10.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">LINH Vu</div>
                  <div class="content__position">DEVOPS LEAD</div>
                  <div class="content__description">
                    <p>Over 13 years of experience in programming, operating, and deploying products on AWS (EC2, EKS, S3 …), and other cloud systems, Linh not only ensures that products’ systems connect to each other quickly but also administer the complex
                      systems effectively.</p>
                    <p>Beside he always find the best solutions to change the environments for the development team at the least risks.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 10}"></div>
            </div>
            <div class="col-sm-6 col-lg-4 mx-auto">
              <div class="card__team">
                <div class="card__team-image">
                  <img src="/assets/images/layouts/team-item-11.jpg" alt="team">
                </div>
                <div class="card__team-content">
                  <div class="content__info">
                    <div class="content__info-name">NGAN Pham</div>
                    <div class="content__info-position">HUMAN RESOURCE MANAGER</div>
                  </div>
                  <button class="content__button buttonTeam" @click="detailLeader = 11">
                    <span></span>
                  </button>
                </div>
              </div>
              <div class="card__info" :class="{'show': detailLeader === 11}">
                <div class="card__info-image">
                  <img src="/assets/images/layouts/team-item-11.jpg" alt="team">
                </div>
                <div class="card__info-content">
                  <div class="content__name">NGAN Pham</div>
                  <div class="content__position">HUMAN RESOURCE MANAGER</div>
                  <div class="content__description">
                    <p>In the competitive and fast changing IT industry, with a deep understanding of the IT industry and a broad network, Ngan always ensures quantity as well as high-quality of IT resource to help satisfy needs of both projects and clients.</p>
                  </div>
                </div>
                <button class="card__info-close buttonClose" @click="detailLeader = ''">
                  <span></span>
                </button>
              </div>
              <div class="card__overlay" :class="{'show': detailLeader === 11}"></div>
            </div>
            <div class="col-sm-6 col-lg-4 mx-auto"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Leadership -->
  </main>
</template>
<script>
export default {
  data() {
    return {
      detailLeader: ''
    }
  }
}
</script>
